import React, { useState, useEffect } from 'react'
import banner from './banner.jpg'
import Subscribe from './Subscribe'
import Logo from 'js/components/Logo'
import distanceInSeconds from 'date-fns/differenceInSeconds'
import { FormattedMessage } from 'react-intl'
import { setItem } from 'js/storeManager'

type Props = {
  subscribedEmail: string | null
  target: string
}

function CountdownPage({ subscribedEmail, target }: Props) {
  const [hasSubmitted, setHasSubmitted] = useState(false)

  return (
    <div className="h-full bg-BgSub">
      <div
        className="bg-BgSub bg-cover pb-56 pt-80 text-center md:pb-128 md:pt-96 lg:pb-96 xl:pb-128"
        style={{
          background: `linear-gradient(162deg,rgba(19, 20, 27, 0.4),rgba(19, 20, 27, 0.9)), url(${banner})`,
        }}
      >
        <div className="o-width-limiter font-demibold uppercase tracking-caps text-white type-14 lg:type-20-demibold-caps">
          <div className="pb-16 md:pb-36">
            <FormattedMessage id="webinar_countdown_heading" />
          </div>
          <div className="mb-8 tracking-2 text-white type-56-bold md:type-72-bold lg:type-96-bold xl:pt-40">
            <Countdown target={target} />
          </div>
        </div>
      </div>

      <div className="mb-32 flex flex-col justify-center px-20 py-36 text-center">
        <h1 className="mb-24 type-32-demibold md:type-40-demibold">
          <FormattedMessage id="webinar_heading" />
        </h1>
        <p className="mx-auto mb-36 max-w-576">
          <FormattedMessage id="webinar_subheading" />
        </p>
        <h3 className="mb-12 type-20-demibold">
          <FormattedMessage id="webinar_info_callout" />
        </h3>
        <p className="mx-auto mb-12 max-w-768 leading-body">
          <FormattedMessage id="webinar_info_1" />
        </p>
        <p className="mx-auto mb-12 max-w-768 leading-body">
          <FormattedMessage id="webinar_info_2" />
        </p>
        <div className="mx-auto my-36 max-w-768 rounded-20 border border-Border bg-white px-16 py-48 md:px-48 lg:my-48">
          {!subscribedEmail && !hasSubmitted && (
            <h1 className="mb-36 type-24-demibold md:type-32-demibold">
              <FormattedMessage id="webinare_register_dont_miss" />
            </h1>
          )}
          <div className="max-w-512">
            <Subscribe
              isSubscribed={subscribedEmail}
              onSubscribed={(email) => {
                setHasSubmitted(true)
                setItem('webinar-subscribe-email', email)
              }}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-center pb-72">
        <Logo />
      </div>
    </div>
  )
}

type CountdownProps = {
  target: string
}
function Countdown({ target }: CountdownProps) {
  const [_count, setCount] = useState(0)
  useEffect(() => {
    setInterval(() => {
      setCount((count) => count + 1)
    }, 1000)
  }, [])

  let difference = distanceInSeconds(new Date(target), new Date())
  const days = Math.floor(difference / (60 * 60 * 24))
  difference = difference % (24 * 60 * 60)
  const hours = Math.floor(difference / (60 * 60))
  difference = difference % (60 * 60)
  const minutes = Math.floor(difference / 60)
  const seconds = Math.floor(difference % 60)

  return (
    <div className="mx-auto grid max-w-480 grid-cols-4 px-0 md:px-0 lg:max-w-576">
      <div className="flex flex-col items-center text-center">
        {days}{' '}
        <span className="text-20">
          <FormattedMessage id="webinar_days" />
        </span>
      </div>
      <div className="flex flex-col items-center text-center">
        {hours}{' '}
        <span className="text-20">
          <FormattedMessage id="webinar_hours" />
        </span>
      </div>
      <div className="flex flex-col items-center text-center">
        {minutes}{' '}
        <span className="text-20">
          <FormattedMessage id="webinar_minutes" />
        </span>
      </div>
      <div className="flex flex-col items-center text-center">
        {seconds}{' '}
        <span className="text-20">
          <FormattedMessage id="webinar_seconds" />
        </span>
      </div>
    </div>
  )
}

export default CountdownPage
